var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusThick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2C11 0.895431 10.1046 0 9 0V0C7.89543 0 7 0.89543 7 2V7H2C0.895431 7 0 7.89543 0 9V9C0 10.1046 0.89543 11 2 11H7V16C7 17.1046 7.89543 18 9 18V18C10.1046 18 11 17.1046 11 16V11H16C17.1046 11 18 10.1046 18 9V9C18 7.89543 17.1046 7 16 7H11V2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusThick);
export default __webpack_public_path__ + "static/media/plus-thick.f5de6875ee30734e44e3cc84b597c20d.svg";
export { ForwardRef as ReactComponent };